import React, { createContext, useCallback, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { DEFAULT_THEME_ID, STORAGE_KEY, THEME_BY_ID, THEMES } from '../theme/themes';

const ThemeContext = createContext(null);

function readStoredTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && THEME_BY_ID[stored]) return stored;
  } catch {
    /* ignore */
  }
  return DEFAULT_THEME_ID;
}

export function ThemeProvider({ children }) {
  const [themeId, setThemeId] = useState(readStoredTheme);

  useLayoutEffect(() => {
    document.documentElement.setAttribute('data-theme', themeId);
    try {
      localStorage.setItem(STORAGE_KEY, themeId);
    } catch {
      /* ignore */
    }
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', THEME_BY_ID[themeId].themeColor);
  }, [themeId]);

  const setTheme = useCallback((id) => {
    if (THEME_BY_ID[id]) setThemeId(id);
  }, []);

  const value = useMemo(
    () => ({
      themeId,
      theme: THEME_BY_ID[themeId],
      themes: THEMES,
      setTheme,
    }),
    [themeId, setTheme],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
